<a
  class="btn btn-secondary"
  [ngClass]="signInClass"
  routerLink="/login"
  [queryParams]="{ returnUrl: returnUrl }"
  translate
>
  account.signin.auth0.button.label
</a>
